import { Button } from "@minket/ui/components/button";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { ErrorState } from "@/components/page/states";

/**
 * What a page shows when it throws while rendering, or its code fails to load (a deploy
 * replaced the chunk): the error in words and a way out, inside the shell, never a blank
 * screen.
 */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const chunkFailed =
    error instanceof Error &&
    /dynamically imported module|Importing a module script/i.test(error.message);
  return (
    <div className="grid gap-4">
      <ErrorState
        title={chunkFailed ? "This page needs a reload" : "This page stopped working"}
        error={
          chunkFailed
            ? new Error("The console was updated while it was open. Reload to get the new version.")
            : error
        }
        onRetry={chunkFailed ? undefined : reset}
      />
      <div>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Reload the page
        </Button>
      </div>
    </div>
  );
}
